<script lang="ts">
    import { trans } from '$assets/shop-translator.js';

    export let remainingStock: number | null | undefined;
</script>

{#if remainingStock}
    <div class="text-center">
        <!--  eslint-disable-next-line svelte/no-at-html-tags -->
        {@html trans('tour.aside_panel.travelgate.remaining', {
            '%count%': remainingStock,
        })}
    </div>
{/if}
